import { createActivity } from './activity';
import { ExpLogger } from './exp-logger';

let instrumentation;

export class ExpLoggerFactory {
  /**
   * Initialize factory with existing instrumentation instance
   * @param {Object} instr - existing instrumentation instance
   * @returns {void}
   */
  static init(instr) {
    instrumentation = instr;
  }

  /**
   * Create an experiment logger
   * @param {string} name - experiment name
   * @returns {Object} ExpLogger instance that created
   */
  static createLogger(name) {
    let activity = null;
    if (instrumentation) {
      activity = createActivity(instrumentation);
    }
    return new ExpLogger(name, activity);
  }
}
